import React, {Component} from 'react';
import {Link, useNavigate} from "react-router-dom";
import {faCircleNotch} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Cropper from "react-easy-crop";
import Agent from "../../Network/Agent";
import {getCroppedImg} from "../../Components/Utils/CanvasUtils";
import ToolBar from "../../Components/Elements/ToolBar";
import {getGeneratedRoute, RouteEnumFinal} from "../../Config/RouteEnum";
import ButtonPrimary from "../../Components/Elements/ButtonPrimary";
import ButtonSecondary from "../../Components/Elements/ButtonSecondary";
import BottomSheetAction from "../../Components/Elements/BottomSheet/BottomSheetAction";
import BottomSheetConfirm from "../../Components/Elements/BottomSheet/BottomSheetConfirm";
import {ActionButtonsEnum} from "../../Components/Elements/BottomSheet/Enum/ActionButtonsEnum";
import {BASE_URL} from "../../Config/SharedConfig";


class GalleryEditInternal extends Component {


    constructor(props) {
        super(props);
        this.state = {
            productCode : window.location.pathname.split('/')[2] ,
            storeUsername : window.location.host.split('.')[0] ,
            modal : {
                actions : false,
                confirm : false,
                confirmDeleteFile : false
            },
            temporaryData : '',
            isLoading : {
                confirm : false,
                confirmDeleteFile : false,
                imageUpload : false
            },
            isDisabled : {
                confirm : false
            },
            files : [],
            underConstructionFileCode : '',
            imageSrc : "",
            crop: { x: 0, y: 0 },
            zoom: 1,
            rotation : 0,
            aspect: 1,
            croppedImage : null,
            cropCntDisplay : "none",
        }
    }

    toggleModal = (target) => e => {
        let modal = this.state.modal
        modal[target] = !modal[target]
        this.setState({
            modal
        })
    }
    onBottomSheetCallBack = (type , data) => {
        console.log(type)
        if (type === 'delete') {
            this.setState({
                modal : {
                    actions : false,
                    confirmDeleteFile : true,
                }
            })
        }
        if (type === 'default') {
            this.setState({
                modal : {
                    actions : false
                }
            })
            Agent.File.setDefault(data)
                .then(response => {
                    this.requestGetFiles()
                })
                .catch(error => {
                    console.log(error.response)
                    //    todo toast message
                })
        }
    }
    onBottomSheetConfirmDeleteFileCallBack = (type , data) => {
        if (type === 'positive') {
            this.setState({
                isLoading : {
                    confirmDeleteFile : true
                }
            })
            Agent.File.delete(data)
                .then(response => {
                    this.setState({
                        modal : {
                            confirmDeleteFile : false
                        },
                        isLoading : {
                            confirmDeleteFile : false
                        }
                    })
                    this.requestGetFiles()
                })
                .catch(error => {
                    console.log(error.response)
                })
        }
        if (type === 'negative') {
            this.setState({
                modal : {
                    confirmDeleteFile : false
                }
            })
        }
    }

    readFile = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader()
            reader.addEventListener('load', () => resolve(reader.result), false)
            reader.readAsDataURL(file)
        })
    }
    onFileChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0]
            let imageDataUrl = await this.readFile(file)

            /*const ORIENTATION_TO_ANGLE = {
                '3': 180,
                '6': 90,
                '8': -90,
            }
            const orientation = await getOrientation(file)
            const rotation = ORIENTATION_TO_ANGLE[orientation]
            if (rotation) {
                imageDataUrl = await getRotatedImage(imageDataUrl, rotation)
            }*/

            this.setState({
                imageSrc : imageDataUrl,
                cropCntDisplay : "block"
            })
        }
    }
    onCropChange = (crop) => {
        this.setState({ crop })
    }
    onCropComplete = (croppedArea, croppedAreaPixels) => {
        getCroppedImg(this.state.imageSrc,croppedAreaPixels,this.state.rotation)
            .then((data) => {
                this.setState({
                    croppedImage : data,
                })
            })
            .catch((error) => {
                console.log(error)
            })
    }
    onCropClose = () => {
        document.getElementById("input_image").value = null;
        this.setState({
            imageSrc : "",
            crop: { x: 0, y: 0 },
            zoom: 1,
            rotation : 0,
            aspect: 1,
            croppedImage : null,
            cropCntDisplay : "none",
        })
    }
    onZoomChange = (zoom) => {
        this.setState({ zoom })
    }
    onRotationChange = (rotation) => {
        this.setState({ rotation })
    }
    dataURLtoFile = (dataUrl, filename) => {
        let arr = dataUrl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    }
    uploadCroppedImage = () => {
        this.setState({
            isLoading : {
                imageUpload : true
            }
        })
        let file = this.dataURLtoFile(this.state.croppedImage , "image.jpeg")
        let formData = new FormData();
        formData.append("file", file);

        document.getElementById("input_image").value = null;

        let config = function(progressEvent) {
            let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
            let bodyCover = document.getElementById("body-cover");
            bodyCover.style.display = "block"
            if (percentCompleted === 100) {
                bodyCover.style.display = "none"
            }
        };
        Agent.File.uploadProductGallery(this.state.productCode , formData , config)
            .then(response => {
                // console.log(response)
                this.requestGetFiles()
                this.setState({
                    isDisabled : {
                        confirm : false
                    },
                    isLoading : {
                        imageUpload : false
                    },
                    cropCntDisplay : "none",
                    imageSrc : "",
                    crop: { x: 0, y: 0 },
                    zoom: 1,
                    rotation : 0,
                    aspect: 1,
                    croppedImage : null,
                })
            })
            .catch(error => {
                console.log(error.response)
                this.setState({
                    isDisabled : {
                        confirm : false
                    },
                    isLoading : {
                        imageUpload : false
                    },
                    cropCntDisplay : "none",
                    imageSrc : "",
                    crop: { x: 0, y: 0 },
                    zoom: 1,
                    rotation : 0,
                    aspect: 1,
                    croppedImage : null,
                })
            })
    }


    openActionsModalForImage = (code) => (e) => {
        console.log(code)
        this.setState({
            underConstructionFileCode : code,
            modal : {
                actions : true
            }
        })
    }

    requestGetFiles = () => {
        Agent.Product.getFiles(this.state.productCode)
            .then(response => {
                let files = response.data.result.files
                this.setState({
                    files : files
                })
            })
            .catch(error => {
                console.log(error.response)
            })
    }

    componentDidMount() {
        this.requestGetFiles()
    }

    render() {
        return (
            <>
                {/*todo check if got here from edit product or add product*/}
                <ToolBar title={'گالری'} navigate={this.props.toolbarNavigate} />

                <div id="body-cover">
                    <div className='content'>
                        <div className='text-center'>
                            <FontAwesomeIcon className="fa-spin" icon={faCircleNotch} style={{fontSize: '30px', color: '#FFFFFF'}}/>
                        </div>
                        <div className="mobile-body-1-strong cl-white mt-10 dir-rtl">
                            در حال بارگذاری فایل...
                        </div>
                    </div>
                </div>


                <div className="crop-container" style={{"display" : this.state.cropCntDisplay}}>
                    <Cropper
                        image={this.state.imageSrc}
                        crop={this.state.crop}
                        zoom={this.state.zoom}
                        rotation={this.state.rotation}
                        aspect={this.state.aspect}
                        onCropChange={this.onCropChange}
                        onCropComplete={this.onCropComplete}
                        onZoomChange={this.onZoomChange}
                        onRotationChange={this.onRotationChange}
                    />

                    <div className="btn-cnt">
                        <div className="container">
                            <div className="row">
                                <div className="col-3">
                                    <div onClick={() => { this.setState({ rotation : 0 }) }} className="rotation-btn text-center">
                                    <span className="mobile-body-1-strong desktop-body-1-strong cl-black ">
                                        &#176; 0
                                    </span>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div onClick={() => { this.setState({ rotation : 90 }) }} className="rotation-btn text-center">
                                    <span className="mobile-body-1-strong desktop-body-1-strong cl-black ">
                                        &#176; 90
                                    </span>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div onClick={() => { this.setState({ rotation : 180 }) }} className="rotation-btn text-center">
                                    <span className="mobile-body-1-strong desktop-body-1-strong cl-black ">
                                        &#176; 180
                                    </span>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div onClick={() => { this.setState({ rotation : 270 }) }} className="rotation-btn text-center">
                                    <span className="mobile-body-1-strong desktop-body-1-strong cl-black ">
                                        &#176; 270
                                    </span>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-8">
                                <div className="col-6">
                                    <div
                                        onClick={this.uploadCroppedImage}>
                                        <ButtonPrimary
                                            mode="dark-mode"
                                            isLoading={this.state.isLoading.imageUpload}
                                            text="آپلود" />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div onClick={this.onCropClose}>
                                        <ButtonSecondary
                                            isLoading={false}
                                            text="انصراف" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='container'>
                    <div className={'col-12'}>
                        <div className={'mobile-h3 cl-black mt-10'}>
                            اطلاعات محصول شما با <span className='cl-grass'>موفقیت</span> ثبت شد !
                        </div>
                    </div>
                    <div className={'row'}>
                        <div className={'col-12'}>
                            <div className={'mobile-subtitle-regular cl-subtitle mt-8'}>
                                {
                                    this.state.files.length === 0
                                        ? "لطفا تصاویر محصول مورد نظر خود را در صورت تمایل بارگذاری کنید :"
                                        : "برای نمایش تنظیمات و یا حذف عکس روی تصویر ضربه بزنید"
                                }
                            </div>
                        </div>
                    </div>
                    <div className={'row g-2 mt-8'}>
                        <div className={'col-4'}>
                            <form encType='multipart/form-data' noValidate={true}>
                                <div className='form-group-gallery'>
                                    <label className="form-group-label">
                                        <input onChange={this.onFileChange}
                                               id='input_image'
                                               type="file"
                                               className='form-group-input'
                                               accept="image/jpeg"/>
                                        <div className={'square-box'}>
                                            <div className={'add-gallery-box'}>
                                                <div>
                                                    <div className={'d-flex justify-content-center'}>
                                                        <div className='img-cnt-30'>
                                                            <img src={"/assets/images/vectors/plus_lightblue.svg"} alt=""/>
                                                        </div>
                                                    </div>
                                                    <div className={'mobile-caption-strong cl-blue mt-8'}>
                                                        عکس جدید
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </form>
                        </div>

                        {
                            this.state.files.map(file => {
                                return(
                                    <div key={file.code} className='col-4'>
                                        <div className='square-box' onClick={this.openActionsModalForImage(file.code)}>
                                            <div className={"border-radius-8px "+(file.queue===1 ? "default-image-indicator" : "")}
                                                 style={{backgroundColor : file.dominantColor.hex}}>
                                                {
                                                    file.queue===1
                                                        ?   (<div className="default-text-cnt">
                                                            پیشفرض
                                                        </div>)
                                                        :   ("")
                                                }

                                                <div className='img-cnt-filled'>
                                                    <img src={BASE_URL+file.internalPath} alt="logo" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }

                    </div>
                </div>

                <div className='scroll-fixer'/>
                <div className='btn-fixed-bottom'>
                    <Link to={getGeneratedRoute(RouteEnumFinal.STORE_MAIN_VIEW_URL_GENERATE , "all")} className='td-none'>
                        <ButtonPrimary mode='dark-mode'
                                       text='انجام شد'
                                       isLoading={false}
                                       isDisabled={this.state.isDisabled.confirm} />
                    </Link>
                </div>



                <BottomSheetAction show={this.state.modal.actions}
                                   onHide={this.toggleModal('actions')}
                                   data={this.state.underConstructionFileCode}
                                   buttons={[
                                       ActionButtonsEnum.DELETE ,
                                       ActionButtonsEnum.DEFAULT ,
                                   ]}
                                   action={this.onBottomSheetCallBack} />


                <BottomSheetConfirm show={this.state.modal.confirmDeleteFile}
                                    onHide={this.toggleModal('confirmDeleteFile')}
                                    title={"حذف عکس "}
                                    body='آیا از حذف این عکس اطمینان دارید ؟'
                                    data={this.state.underConstructionFileCode}
                                    action={this.onBottomSheetConfirmDeleteFileCallBack}
                                    isLoading={this.state.isLoading.confirmDeleteFile}
                                    btnText='حذف' />

            </>
        );
    }
}

const GalleryEdit = () => {
    const navigate = useNavigate()
    return <GalleryEditInternal toolbarNavigate={() => navigate(-1)} />
}

export default GalleryEdit